export const environment = {
  production: true,
  env_file: "dev",

  config:{
    apiV1Url:'https://api.ddo.dental',
    apiUrl:'https://api.dev.itek.dental:3000',
    hasuraWss: 'wss://hasura.dev.itek.dental:8070/v1/graphql',
    hasuraUrl: 'https://hasura.dev.itek.dental:8070/v1/graphql'
  },
  jwt:{
    iss:"iTek",
    sub:"itek@itek.dental",
    aud:"itek.dental"
  }
};
